const UseGetterNodeError = (currentNode, tabName, fieldName) => {
    if(
        currentNode &&
        currentNode.data.form &&
        currentNode.data.form.tabs &&
        currentNode.data.form.tabs[tabName] &&
        currentNode.data.form.tabs[tabName].fields &&
        currentNode.data.form.tabs[tabName].fields[fieldName] &&
        currentNode.data.form.tabs[tabName].fields[fieldName].error
    ){
        return currentNode.data.form.tabs[tabName].fields[fieldName].error
    }

    return null
}

export default UseGetterNodeError

